import { currentPage } from '../common/layout';
import { getStroeerGalleryBanners } from '../common/utils/adv-stroeer-mobile-gallery-loader';
import 'jquery-mousewheel';
import '../common/lightgallery/jquery-lightgallery';
import '../common/lightgallery/jquery-lightgallery-aside';
import '../common/lightgallery/jquery-lightgallery-additional';
import '../common/lightgallery/jquery-lightgallery-topside';
import '../common/lightgallery/jquery-lightgallery-custom-content';
import '../common/msnt/msnt-lightslider.js';
// import '../common/lazyload.picture';
import { getCookie } from '../common/utils/fn';
import { msntPhotoThumbGallery } from '../common/msnt/msnt-loader';

currentPage.pageInit = ($page, pageData, pageId) => {
  var $dataEdtn = $('body').data('edtn');
  msntPhotoThumbGallery().then((api) => {
    api.msntPhotoThumbGallery();
  });


  var cpAuthhint = getCookie('_cpauthhint');
  if ($dataEdtn == 'de' || $dataEdtn == 'ev_de' && !cpAuthhint) {
    getStroeerGalleryBanners().then((api) => {
      api.initDeMobileGalleryBanners();
    });
  }

  if ($dataEdtn == 'us' || $dataEdtn == 'ra_us' || $dataEdtn == 'ev_us') {
    const headerRequest = new Request(document.location);
    fetch(headerRequest).then((response) => {
      const headerTitle = "Geoip-Country";
      if(response.headers.has(headerTitle)){
        var title = response.headers.get(headerTitle);
        gtmDataLayer.push({
          event: 'geoIpIsPresent',
          'userGeoIp': title
        });
      }
    });
  }

  let galleryButton = document.querySelector('.share-button-gallery');
  galleryButton.addEventListener('click', function(event){
    event.preventDefault();
    event.stopPropagation();
  });
};
